// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__Mqsyl","logo":"MainNavigation_logo__B0q40","active":"MainNavigation_active__PfiwL"};